'use client';

import { ReactNode } from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { FormError, FormSuccess } from '@/components/form';

interface SettingsSectionWrapperProps {
  title: string;
  description?: string;
  children: ReactNode;
  error?: string;
  success?: string;
  footer?: ReactNode;
}

export function SettingsSectionWrapper({
  title,
  description,
  children,
  error,
  success,
  footer,
}: SettingsSectionWrapperProps) {
  return (
    <div className="w-full max-w-4xl">
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent className="space-y-6">
          {children}

          {(error || success) && (
            <div className="space-y-2">
              <FormError message={error} />
              <FormSuccess message={success} />
            </div>
          )}

          {footer && <div className="pt-4">{footer}</div>}
        </CardContent>
      </Card>
    </div>
  );
}
